import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import Button from '../shared/Button/Button';
import { navbarStyles as styles } from './navbar.tailwind';
import routeConstant from '../../lib/constants/routeConstant';
import Profile from './ProfileComponent';
import Cart from './Cart';
import SeasonDropDown from '../SeasonDropDown/SeasonDropDown'
import { APP_LOGO_IMAGE } from '../../lib/constants/globalConstant';
import { setMyAccountActiveTab } from '../../redux/slices/publicSlice';
import { MY_ACCOUNT_TABS } from '../MyAccount/myAccountTabsData';
import UpcomingLiveGameBanner from '../UpcomingLiveGameBanner/UpcomingLiveGameBanner';
import OverlayLoader from '../shared/Loaders/OverlayLoader/OverlayLoader';
import middleImage from '../../assets/svgs/ucla_logo.svg';

const Navbar = ({
  courtTitle, // title of the court
  showCart = true,   // show cart button
  showProfile = true,  // show profile
  disableCart = false, // disable cart
  showSeasonDropdown = false, // show season dropdown
  showLiveGame = false,
  setActiveTab,
  showMiddleImage = true,
}) => {
  const navigate = useNavigate();
  const { isSignedIn } = useSelector((state) => state.user);
  const { totalCount } = useSelector((state) => state.cart);
  const { liveMatches } = useSelector((state) => state.sport);
  const _showCart = !totalCount ? false : showCart;

  const [seasonUpdating, setSeasonUpdating] = useState(false);

  return (
    <nav className={styles.container}>
      {seasonUpdating && (<OverlayLoader />)}

      <div className={styles.wrapper}>
        {/* Left: Logo */}
        <Link to={isSignedIn ? routeConstant.MY_ACCOUNT_PAGE : "/"}
          onClick={() => {
            if (isSignedIn) {
              setActiveTab(MY_ACCOUNT_TABS.DEFAULT_TAB);
            }
          }}
        >
          <img src={APP_LOGO_IMAGE} alt="Logo" className={styles.logo} />
        </Link>

        {/* Middle: Custom Image */}
        {showMiddleImage && (
          <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2">
            <img src={middleImage} alt="Middle Icon" className="w-[70px] screen-500:!w-[100px] h-auto" />
          </div>
        )}

        {/* Center: Heading */}
        {/* {!isSignedIn && (
          <h1 className={styles.heading}>Purcell Pavilion Tokens</h1>
        )} */}

        {/* courtTitle if any */}
        {courtTitle && <h1 className={styles.heading}>{courtTitle}</h1>}
        {!courtTitle && isSignedIn && showLiveGame && liveMatches?.length > 0 && (
          <div className='hidden screen-970:flex'>
            <UpcomingLiveGameBanner />
          </div>
        )}

        {/* Right: Login Button */}
        {isSignedIn ? (
          <div className={styles.side_btns_wrpr}>
            {showSeasonDropdown && (
              <div className='hidden screen-850:flex'>
                <SeasonDropDown setSeasonUpdating={setSeasonUpdating} />
              </div>
            )}
            {/* Cart Section */}
            {_showCart && <Cart disableCart={disableCart || !totalCount} />}

            {/* Profile Section */}
            {showProfile && <Profile showSeasonDropdown={showSeasonDropdown} setSeasonUpdating={setSeasonUpdating} />}
          </div>
        ) : (
          <Button
            className={styles.login_btn}
            variant="primary"
            onClick={() => navigate(routeConstant.LOGIN_PAGE)}
          >
            Login
          </Button>
        )}
      </div>

      {!courtTitle && isSignedIn && showLiveGame && liveMatches?.length > 0 && (
        <div className='screen-970:hidden flex justify-center mt-1'>
          <UpcomingLiveGameBanner />
        </div>
      )}
    </nav>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setActiveTab: (data) => dispatch(setMyAccountActiveTab(data)),
})

export default connect(null, mapDispatchToProps)(Navbar);
